import type { FunctionComponent } from 'react'
import React from 'react'

import { TypographyV2 } from '../../../Seatbelt2/Foundations/Typography'
import type { File } from '../ExtendedInfoDownload'
import styles from './Print.module.scss'
import { getDescription, getFileSize } from './Print.utils'

export const Print: FunctionComponent<PrintProps> = ({ file, url }) => {
  const [fileSize, sizeUnit] = getFileSize(file.size)

  if (!file.name || !file.description) {
    return (
      <TypographyV2 textStyle="sb-text-interface-body-small-regular" className={styles.container}>
        There is a file available for download. ({file.type} &mdash; {fileSize} {sizeUnit}). This
        file is available for download at {url}.
      </TypographyV2>
    )
  }

  return (
    <TypographyV2 textStyle="sb-text-interface-body-small-regular" className={styles.container}>
      There is a file available for download. {file.name} ({file.type} &mdash; {fileSize} {sizeUnit}
      ). {getDescription(file.description)} This file is available for download at {url}.
    </TypographyV2>
  )
}

///////// IMPLEMENTATION /////////

type PrintProps = {
  file: File
  url: string
}
